module.exports = __webpack_public_path__ + "static/img/doctor_register.af78fcd.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/doctor_register.jpg
// module id = mSfy
// module chunks = 7